import * as React from 'react';
import styled from '@emotion/styled';

import professor from '~/images/prof.png';

import { useAuthSelector } from '../containers/Auth';
import Modal from './Modal';

const ModalContent = styled.div`
  & * {
    font: revert;
  }

  line-height: 30px;
  margin: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  img {
    width: 150px;
  }
`;

/* Shown -- and never dismissed -- when the site's board (or the site itself)
 * has MCP's ALLOW_META_PIXELS setting turned off. Every ad this tool publishes
 * carries a Meta conversion pixel, so there is no version of this tool that
 * works for those sites; the backend 403s everything but login and the site
 * switcher. Say why, so nobody files a bug about the tool being broken.
 */
function MetaPixelsBlockedModal() {
  const blocked = useAuthSelector(state => state.matches('metaPixelsBlocked'));
  const siteDomain = useAuthSelector(state => state.context.rgUser?.site_domain);

  return (
    <Modal
      isOpen={blocked}
      withClose={false}
      onClose={() => {}}
      contentStyle={{ maxWidth: 700, height: 'auto' }}
    >
      <ModalContent>
        <img src={professor} alt="Real Geeks professor logo" />
        <h3>The Facebook Ads Manager is not available for this site</h3>
        <p>
          Tracking pixels are turned off for
          {siteDomain ? ` ${siteDomain}` : ' this site'}
          , because its state does not allow them. California&apos;s Invasion of
          Privacy Act (CIPA) and similar laws restrict the tracking codes that
          third parties like Facebook use to measure ads.
        </p>
        <p>
          Every ad this tool creates depends on a Facebook tracking pixel, so
          the tool is turned off here. Existing ads are managed in&nbsp;
          <a
            href="https://business.facebook.com"
            target="_blank"
            rel="noreferrer noopen"
          >
            Facebook Ads Manager
          </a>
          .
        </p>
        <p>
          If you believe this is a mistake, or you manage sites in other
          states, please contact&nbsp;
          <a href="https://support.realgeeks.com" target="_blank" rel="noreferrer noopen">
            Real Geeks support
          </a>
          .
        </p>
      </ModalContent>
    </Modal>
  );
}

export default MetaPixelsBlockedModal;
